<template>
  <div class="row">
    <div
      class="col-lg-12"
    >
      <div
        style="width: fit-content; margin: 0 auto"
      >
        <input
          type="radio"
          id="yes"
          name="yes_or_no"
          @click="confirmChoice = true"
          value="yes"
          v-model="marked"
        />
        <label class="color-black" for="yes">Sim</label>
      </div>
      <div
        style="width: fit-content; margin: 0 auto"
      >
        <input
          type="radio"
          name="yes_or_no"
          @click="confirmChoice = true"
          id="no"
          value="no"
          v-model="marked"
        />
        <label class="color-black" for="no">Não</label>
      </div>
    </div>
    <div class="col-lg-4 col-xs-12">

    </div>
    <div class="col-lg-4 col-xs-12">
      <transition name="fade">
        <button
          v-if="confirmChoice"
          @click="saveAnswer"
          class="btn btn-primary full"
        >
          Confirmar escolha
        </button>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  props: ["question", "index", "currentTime", "answers"],
  data: () => ({
    marked: "",
    confirmChoice: false,
  }),
  mounted() {
    if (this.answers.length > 0) {
      const answer = this.answers.find(
        (answer) => answer.question_id == this.question.id
      );
      if (answer) {
        this.marked = answer.choices.marked[0];
        this.confirmChoice = true;
      }
    }
  },
  methods: {
    saveAnswer() {
      if (this.marked == "") {
        this.$toast.error(`Por favor, selecione uma das opções`);
        return;
      }

      let answers = {
        question_id: this.question.id,
        time_taken: this.currentTime,
        choices: {
          marked: [this.marked],
        },
      };

      axios.post("/candidates/answers", { answers }).then((response) => {
        if (response.status) {
          eventBus.$emit("nextQuestion", this.index);
          this.$emit("saveAnswers", answers);
        }
      });
    },
  },
};
</script>